import 'shared/styles/index.css'

import VueTheMask, { TheMask, mask } from 'vue-the-mask'
import Notifications from 'vue-notification'
import BlockUI from 'vue-blockui'
import axios from 'axios'

import globals from './plugins/globals'

import storePlugin from './plugins/store/install'
import apiPlugin from './api'
import componentsPlugin from './components'
import routerPlugin from './plugins/router'
import vuetifyPlugin from './plugins/vuetify'
import i18nPlugin from './plugins/i18n'

export default {
  install: async (app, { carregaEnums, mount, controllers, customControllers, paths, theme, extendRouterUserHasRole, extendRouterBeforeEach, defaultViews = true}) => {
    app.use(storePlugin)
    app.use(apiPlugin, { controllers, customControllers })
    app.use(vuetifyPlugin, { theme, callback: (value) => { app.vuetify = value } })
    app.use(routerPlugin, { theme, paths, extendRouterUserHasRole, extendRouterBeforeEach, defaultViews, callback: (value) => { app.router = value } })
    app.use(componentsPlugin)
    app.use(i18nPlugin, { callback: (value) => { app.i18n = value } })

    const favicon = document.getElementById('favicon')
    if (favicon) { favicon.href = require('shared/images/svg/favicon.svg') }

    app.config.productionTip = false
    app.prototype.global = {
      GuidEmpty: '00000000-0000-0000-0000-000000000000'
    }

    app.use(VueTheMask)
    app.component(TheMask)
    app.directive('mask', {
      bind: function (el, binding) {
        el.setAttribute('data-mask', binding.value)
        mask(el, binding)
      }
    })

    app.use(Notifications)
    app.use(BlockUI)

    app.mixin({
      data: globals,
      methods: {
        userHasRole (role) {
          if (role && this.$router) { return this.$router.userHasRole(role) } else { return true }
        }
      }
    })

    await version()
    await getEnum(app.prototype.$api, carregaEnums !== false)

    mount({
      router: app.router,
      vuetify: app.vuetify,
      i18n: app.i18n,
      axios,
      created:() => {
      }
    })
  }
}

async function getEnum (api, carregaEnums) {
  if (carregaEnums) {
    // Carregar Arrays e Enums
    const response = await api.Enum.GetAll()

    var items = Object.keys(response)
    api.Enums = {}
    api.Arrays = {}
    items.forEach(function (p) {
      api.Enums[p] = {}
      response[p].forEach(function (o) {
        api.Enums[p][o.name] = o.value
      })

      api.Arrays[p] = []
      response[p].forEach(function (o) {
        api.Arrays[p].push({
          value: o.value,
          text: o.description,
          name: o.name
        })
      })
    })
  }
}

async function version () {
  try {
    const { data } = await axios.get('/version.json')

    const version = localStorage.getItem('appVersion')
    if (data.version && version !== data.version) {
      localStorage.setItem('appVersion', data.version)
      location.reload()
    }
  } catch {}
}
